import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "label" }

import Colors from '@/utils/colors'
import { useI18n } from 'vue-i18n'
import { watchEffect, ref } from 'vue'
import { useRealm } from '@/composables/useRealm'

export default /*@__PURE__*/_defineComponent({
  __name: 'DashboardLegend',
  setup(__props) {

const { t } = useI18n()
const { filtersMap } = useRealm()
const items: Array<{ title: string; color: string }> = [
  {
    title: t('general__text__used'),
    color: Colors.graph.blue
  },
  ...(filtersMap.ONLY_BOOKABLE
    ? [
        {
          title: t('general__text__booked'),
          color: Colors.graph.orange
        }
      ]
    : []),
  {
    title: t('general__text__not-used'),
    color: Colors.graph.gray
  }
]
const computedPosition = ref(false) // Start with initial value
const updateComputedPosition = () => {
  computedPosition.value = window.innerWidth <= 1024
}
updateComputedPosition()

// Watcher for window resize
watchEffect(() => {
  window.addEventListener('resize', updateComputedPosition)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: "graphs-legend",
    class: _normalizeClass({
      'graphs-legend-container': !computedPosition.value,
      'graps-legend-container-fullscreen': computedPosition.value
    })
  }, [
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(items, (item, i) => {
      return _createElementVNode("div", {
        key: i,
        class: "item"
      }, [
        _createElementVNode("div", {
          class: "circle",
          style: _normalizeStyle({ 'background-color': item.color })
        }, null, 4),
        _createElementVNode("span", _hoisted_1, _toDisplayString(item.title), 1)
      ])
    }), 64))
  ], 2))
}
}

})